import compact from 'lodash/compact';
import flatMapDeep from 'lodash/flatMapDeep';
import type { ADF } from '@atlassian/jira-rich-content';

type AdfContentItem = {
	type?: string;
	content?: ADF['content'];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[key: string]: any;
};

export type MentionItem = AdfContentItem & {
	type: 'mention';
	attrs: {
		id: string;
		text: string;
		accessLevel?: string;
	};
};

export const findMentionsInAdfContent: (elements: AdfContentItem | undefined) => MentionItem[] = (
	elements,
) => {
	if (!elements) {
		return [];
	}
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return compact(
		flatMapDeep(elements, (element: AdfContentItem) => {
			if (element?.type && element.type === 'mention') {
				return element;
			}
			if (element?.content) {
				return findMentionsInAdfContent(element.content);
			}
			return null;
		}),
	) as MentionItem[] | [];
};
